import { render } from "./Forms.vue?vue&type=template&id=37512d1f&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"

import "./Forms.vue?vue&type=style&index=0&id=37512d1f&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37512d1f"]])

export default __exports__